export const TokenUrl = {
  TOKENS: '/tokens',
  TOKEN: '/tokens/{tokenId}',
} as const;
